import React from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { useLang } from "../i18n";
import { Cloud, Flower, Sparkle } from "./decor";

const CARD_COLORS = ["bg-pPink", "bg-pBlue", "bg-cardGreen", "bg-pYellow", "bg-pLavender", "bg-pPeach"];

export default function Testimonials() {
  const { s } = useLang();
  return (
    <section id="reviews" data-testid="testimonials-section" className="relative py-20 sm:py-24 overflow-hidden">
      <Cloud className="absolute right-[5%] top-10 w-24 opacity-70 animate-drift" />
      <Flower className="absolute left-[7%] top-20 w-9 animate-sway" petal="#F58FBE" />
      <Sparkle className="absolute right-[12%] bottom-16 w-7 hidden md:block" color="#E08D75" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <span className="font-display text-sm font-semibold tracking-wide text-forest/60 uppercase">
            {s.reviews.eyebrow}
          </span>
          <h2 className="font-display font-bold text-3xl sm:text-4xl lg:text-5xl mt-3 leading-tight">
            <span className="text-sageBlue">{s.reviews.h1}</span>
            <span className="text-coral">{s.reviews.h2}</span>
          </h2>
          <p className="mt-4 text-forest/75 text-base sm:text-lg">{s.reviews.sub}</p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {s.reviews.items.map((r, i) => (
            <motion.figure
              key={r.name}
              data-testid={`review-card-${i + 1}`}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 0.5, delay: (i % 3) * 0.08 }}
              className={`${CARD_COLORS[i % CARD_COLORS.length]} rounded-3xl p-7 shadow-soft hover:-translate-y-1 hover:shadow-card transition-all duration-300`}
            >
              <div className="flex gap-1" aria-label="5 out of 5 stars">
                {Array.from({ length: 5 }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#F5C86A] text-[#E8A93C]" />
                ))}
              </div>
              <blockquote className="mt-4 text-forest/85 text-[15px] leading-relaxed">“{r.q}”</blockquote>
              <figcaption className="mt-5 font-display font-semibold text-forest text-[15px]">
                {r.name}
                <span className="block text-forest/70 text-[13px] font-normal">{r.role}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
